function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { themeColors, themes } from "./definitions";
import { defaultBlack, defaultBlue, defaultYellow } from "../utils/colors";
import { customVariantBlueGrey, customVariantSecondaryAccent, customVariantYellow } from "../utils/customVariant";
import { createMuiTheme } from '@material-ui/core';
export var customDatePickerStyle = function customDatePickerStyle(variant) {
  if (variant === themes.yellow) {
    return {
      highligthBgColor: defaultBlue,
      appBarBackgroundColor: defaultBlue
    };
  }

  if (variant === themes.blueOcean) {
    var pallete = themeColors[variant];
    return {
      highligthBgColor: pallete.secondary.main,
      appBarBackgroundColor: pallete.secondary.main
    };
  }

  return {};
};
export var renderStyledColor = function renderStyledColor(variant) {
  return variant === (themes.yellow || themes.blueGrey || themes.blueOcean) ? 'secondary' : 'primary';
};
export var renderStyledLabel = function renderStyledLabel(label, variant) {
  var customThemes = [themes.yellow, themes.blueGrey, themes.blueOcean];

  if (customThemes.includes(variant)) {
    var pallete = themeColors[variant];
    var customColor = {
      color: pallete.secondary.main
    };
    return /*#__PURE__*/React.createElement("div", {
      style: customColor
    }, label);
  }

  return label;
};
export var customAppBarStyle = function customAppBarStyle(variant) {
  var pallete = themeColors[variant];

  switch (variant) {
    case themes.yellow:
      return {
        titleColor: '#fff',
        subtitleColor: defaultYellow,
        breadcrumbBackgroundColor: defaultYellow,
        breadcrumbTextColor: '#000',
        activeBreadcrumbTextColor: defaultBlue,
        appBarBackgroundColor: defaultBlue
      };

    case themes.blueGrey:
      return {
        activeBreadcrumbTextColor: '#fff'
      };

    case themes.blueOcean:
      return {
        appBarBackgroundColor: pallete.secondary.main,
        titleColor: pallete.primary.contrastText,
        subtitleColor: pallete.primary.main,
        breadcrumbBackgroundColor: pallete.primary.main,
        breadcrumbTextColor: pallete.secondary.main,
        activeBreadcrumbTextColor: pallete.secondary.main
      };

    case themes.shallowBlue:
      return {
        titleColor: pallete.primary.contrastText,
        subtitleColor: defaultBlack,
        breadcrumbBackgroundColor: pallete.secondary.main,
        breadcrumbTextColor: pallete.secondary.contrastText,
        activeBreadcrumbTextColor: pallete.secondary.contrastText
      };

    case themes.wingo:
      return {
        appBarBackgroundColor: '#0B2D44',
        breadcrumbBackgroundColor: '#EF7D14',
        breadcrumbTextColor: '#FFF',
        activeBreadcrumbTextColor: '#0B2D44'
      };

    default:
      return {};
  }
};

var themeGlobals = function themeGlobals(variant) {
  return {
    menuGlobal: {
      breadcrumbContrastText: variant === themes.redLight ? '#000000' : '#ffffff'
    }
  };
};

var themeCustom = function themeCustom(variant, overrides) {
  var themePallete = themeColors[variant];

  switch (variant) {
    case themes.yellow:
      return _objectSpread(_objectSpread({}, customVariantYellow), overrides);

    case themes.blueGrey:
      return _objectSpread(_objectSpread({}, customVariantBlueGrey), overrides);

    case themes.blueOcean:
    case themes.shallowBlue:
      {
        var themeAdjustments = customVariantSecondaryAccent(themePallete);
        return _objectSpread(_objectSpread({}, themeAdjustments), overrides);
      }

    default:
      return _objectSpread({}, overrides);
  }
};

export var theme = function theme(variant, overrides, spacing) {
  var themeCompile = _objectSpread({
    typography: {
      useNextVariants: true
    },
    variant: variant,
    spacing: spacing,
    overrides: _objectSpread({
      MuiCollapse: {
        entered: {
          height: 'auto',
          overflow: 'visible'
        }
      }
    }, themeCustom(variant, overrides)),
    palette: _objectSpread({}, themeColors[variant])
  }, themeGlobals(variant));

  return createMuiTheme(themeCompile);
};